import React from "react";
import ManageDefaultRoutes from "../../ManageDefaultRoutes";
import { Route } from "react-router-dom";
import Dashboard from "../../../pages/Financial/CashInFlow/Dashboard";
import Fees from "../../../pages/Financial/CashInFlow/Fees";
import Grants from "../../../pages/Financial/CashInFlow/Grants";
import Others from "../../../pages/Financial/CashInFlow/Others";
import CashInFlowSheet from "../../../pages/Financial/CashInFlow/Dashboard/CashInFlowSheet";
import UniversalSheet from "../../../pages/Financial/CashInFlow/Dashboard/UniversalSheet";

const CashInFlowRoutes = (
  <>
    <Route path="cashinflow/*">
      <Route index element={<ManageDefaultRoutes path="dashboard" />} />
      <Route path="dashboard">
        <Route index element={<Dashboard />} />
        <Route path="cashinflowsheet" element={<CashInFlowSheet />} />
        <Route path="universalsheet" element={<UniversalSheet />} />
      </Route>
      <Route path="fees" element={<Fees />} />
      <Route path="grants" element={<Grants />} />
      <Route path="others" element={<Others />} />
      <Route path="*" element={<h1>404 Not found</h1>} />
    </Route>
  </>
);

export default CashInFlowRoutes;
